"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var Autologout = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Autologout() {
    var _this;
    _classCallCheck(this, Autologout);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Autologout, [].concat(args));
    _defineProperty(_this, "state", {
      secondsRemaining: 999999999
    });
    _defineProperty(_this, "timer", null);
    _defineProperty(_this, "interval", null);
    _defineProperty(_this, "componentDidMount", function () {
      _this.interval = setInterval(_this._fireHeartbeat, _this.props.heartbeatInterval * 1000);
      if (!_this.props.heartbeatOnly) {
        // Listen for the ajax event
        window.addEventListener('cccisd.ajax', _this._reset, true);
        document.addEventListener('click', _this._reset, true);
        document.addEventListener('keydown', _this._reset, true);
        document.addEventListener('mousemove', _this._reset, true);
        _this._timerStart();
      }
    });
    _defineProperty(_this, "componentWillReceiveProps", function () {
      if (!_this.props.heartbeatOnly) {
        _this._reset();
      }
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      clearInterval(_this.interval);
      clearTimeout(_this.timer);
      window.removeEventListener('cccisd.ajax', _this._reset, true);
      document.removeEventListener('click', _this._reset, true);
      document.removeEventListener('keydown', _this._reset, true);
      document.removeEventListener('mousemove', _this._reset, true);
    });
    _defineProperty(_this, "_fireHeartbeat", function () {
      fetch(Boilerplate.route('api.nexus.user.heartbeat'), {
        credentials: 'include'
      });
    });
    _defineProperty(_this, "_reset", function () {
      _this.refs.warningModal.close();
      clearTimeout(_this.timer);
      _this._timerStart();
      return true;
    });
    _defineProperty(_this, "_timerStart", function () {
      var secs;
      if (_this.props.warn) {
        secs = _this.props.logoutAfter - _this.props.warnDuration;
        _this.timer = setTimeout(_this._startWarn, secs * 1000);
      } else {
        secs = _this.props.logoutAfter;
        _this.timer = setTimeout(_this._secondTimer, secs * 1000);
      }
      _this.setState({
        secondsRemaining: secs
      });
    });
    _defineProperty(_this, "_startWarn", function () {
      _this.refs.warningModal.open();
      _this.setState({
        secondsRemaining: _this.props.warnDuration
      });
      _this._secondTimer();
    });
    _defineProperty(_this, "_secondTimer", function () {
      // set state ever second
      _this.setState({
        secondsRemaining: _this.state.secondsRemaining - 1
      });
      _this.timer = setTimeout(_this._secondTimer, 1000);
    });
    return _this;
  }
  _inherits(Autologout, _React$Component);
  return _createClass(Autologout, [{
    key: "render",
    value: function render() {
      if (this.state.secondsRemaining === 0) {
        clearInterval(this.interval);
        window.location.replace(Boilerplate.url(this.props.logoutURL));
      }
      var showWarning = this.props.warn && this.state.secondsRemaining <= this.props.warnDuration;
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        ref: "warningModal",
        trigger: null,
        onTop: true
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          textAlign: 'center',
          margin: '20px'
        }
      }, "You will be logged off in ", showWarning ? this.state.secondsRemaining : '0', " seconds due to inactivity."), /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          textAlign: 'center',
          margin: '20px'
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          textDecoration: 'underline',
          cursor: 'pointer'
        }
      }, "Click anywhere to prevent logout"))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Autologout, "propTypes", {
  /** The number of seconds to logout after */
  logoutAfter: _propTypes["default"].number,
  /** Should we warn the user with a modal or not? */
  warn: _propTypes["default"].bool,
  /** How long the warning modal will display */
  warnDuration: _propTypes["default"].number,
  /** The url for logout */
  logoutURL: _propTypes["default"].string,
  /** How long in between heartbeats to backend  */
  heartbeatInterval: _propTypes["default"].number,
  /** Is this component only used for heartbeats? */
  heartbeatOnly: _propTypes["default"].bool
});
_defineProperty(Autologout, "defaultProps", {
  // 30 minutes
  logoutAfter: 1800,
  warn: true,
  warnDuration: 60,
  logoutURL: '/api/user/logout',
  // 5 minutes
  heartbeatInterval: 300,
  heartbeatOnly: false
});